import React from "react";
import { Link } from "react-router-dom";

const PublicFooter: React.FC = () => {
	const currentYear = new Date().getFullYear();

	return (
		<footer className="bg-card border-t border-border py-10">
			<div className="container mx-auto px-4 sm:px-6 lg:px-8">
				<div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-10">
					{/* BRAND SECTION */}
					<div className="md:col-span-2">
						<Link to="/" className="flex items-center space-x-2 mb-4">
							<img
								src="/assets/images/desktop_logo.png"
								alt="Dofarahub Logo"
								className="h-9 w-auto object-contain"
							/>
						</Link>

						<p className="text-muted-foreground mb-5 max-w-md text-sm sm:text-base leading-relaxed">
							Find your next home with confidence. Trusted property management,
							verified organizations, and easy tenant onboarding—all in one
							place.
						</p>

						{/* Social Icons - Commented out for now */}
						{/* <div className="flex space-x-3 sm:space-x-4">
							{["X", "Facebook", "Instagram", "Linkedin"].map((icon) => (
								<a
									key={icon}
									href="#"
									className="w-9 h-9 sm:w-10 sm:h-10 bg-muted hover:bg-primary hover:text-primary-foreground rounded-full flex items-center justify-center transition"
									aria-label={icon === "X" ? "X (formerly Twitter)" : icon}
								>
									<Icon name={icon as any} size={18} />
								</a>
							))}
						</div> */}
					</div>

					{/* QUICK LINKS + SUPPORT (Mobile 2x2, Desktop 2-column) */}
					<div className="grid grid-cols-2 gap-6 md:grid-cols-2">
						{/* QUICK LINKS */}
						<div>
							<h3 className="text-xs sm:text-sm font-semibold text-foreground mb-3 uppercase tracking-wider">
								Quick Links
							</h3>
							<ul className="space-y-2 sm:space-y-3 text-sm sm:text-base">
								<li>
									<a
										href="#"
										className="text-muted-foreground hover:text-primary transition"
									>
										For Owners & Agents
									</a>
								</li>
								<li>
									<a
										href="#"
										className="text-muted-foreground hover:text-primary transition"
									>
										About Us
									</a>
								</li>
							</ul>
						</div>

						{/* SUPPORT */}
						<div>
							<h3 className="text-xs sm:text-sm font-semibold text-foreground mb-3 uppercase tracking-wider">
								Support
							</h3>
							<ul className="space-y-2 sm:space-y-3 text-sm sm:text-base">
								<li>
									<a
										href="#"
										className="text-muted-foreground hover:text-primary transition"
									>
										Contact
									</a>
								</li>
								<li>
									<a
										href="#"
										className="text-muted-foreground hover:text-primary transition"
									>
										FAQ
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>

				{/* BOTTOM BAR */}
				<div className="pt-6 border-t border-border">
					<div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
						<div className="text-xs sm:text-sm text-muted-foreground">
							© {currentYear} Dofarahub. All rights reserved.
						</div>

						<div className="flex space-x-4 sm:space-x-6 text-xs sm:text-sm">
							{["Terms", "Privacy"].map((item) => (
								<a
									key={item}
									href="#"
									className="text-muted-foreground hover:text-primary transition"
								>
									{item}
								</a>
							))}
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default PublicFooter;
